
































































































/* General */
import Vue from 'vue'
import RegistrationLayout from '@/layouts/registration-layout.vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import TimeAssistant from '@/helpers/time-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import {
  IItemForSelection,
  IRegistrationOutputCompleteAccount,
} from '@/api/types/response.types'
import { IRegistrationInputCreateAccount } from '@/api/types/request.types'

interface IGoalInfo {
  type: string
  title: string
  subtitle: string
  selected: boolean
}

/* API */
import RegistrationAPI from '@/api/modules/registration.api'
import { EEntities } from '@/types'

export default Vue.extend({
  name: 'AccountRegistrationComplete',

  metaInfo(): any {
    return {
      title: 'Complete account registration',
    }
  },

  components: {
    RegistrationLayout,
    MainContainer,
  },

  data() {
    return {
      EEntities,
      TextAssistant,
      tokenErrorMessage: '',
      isLoading: true,
      isSubmitting: false,
      hasOtherIndustry: false,
      isCouponCodeExposed: false,
      otherIndustry: '',
      completeAccountData: {} as IRegistrationOutputCompleteAccount,
      RouteAssistant,
      currentStepID: 1,
      steps: [] as IItemForSelection[],
      stepInfos: [
        {
          id: 1,
          title: 'About You',
          layoutSize: 'tiny',
        },
        {
          id: 2,
          title: 'About Your Company',
          layoutSize: 'tiny',
        },
      ],
      goalInfos: [] as IGoalInfo[],
      formData: {
        name: '',
        companyName: '',
        companySize: '',
        companyIndustry: '',
        emailAddress: '',
        verificationToken: '',
        couponCode: '',
        password: '',
        passwordConfirm: '',
        timezone: '',
        viaGoogleAuth: false,
        acceptTerms: false,
        acceptEmailList: false,
        listGoals: [] as string[],
        otherGoal: '',
      } as IRegistrationInputCreateAccount,
      step1FormRules: {
        name: [
          {
            validator: (rule: any, value: any, callback: any) => {
              if (value && value.trim() !== '') {
                callback()
              } else {
                callback(new Error('Name is required'))
              }
            },
            trigger: 'blur',
          },
        ],
        password: [
          {
            validator: (rule: any, value: any, callback: any) => {
              // @ts-ignore
              if (this.completeAccountData.viaGoogleAuth) {
                callback()
              }

              if (value.length < 8) {
                callback(new Error('Password must be at least 8 characters'))
              } else if (!/\d/.test(value)) {
                callback(new Error('Password must contain a digit (0-9)'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        passwordConfirm: [
          {
            validator: (rule: any, value: any, callback: any) => {
              // @ts-ignore
              if (this.completeAccountData.viaGoogleAuth) {
                callback()
              }
              // @ts-ignore
              if (value !== this.formData.password) {
                callback(new Error('Password must match'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        timezone: [{ required: true, message: 'Timezone is required' }],
      },
      step2FormRules: {
        companyName: [
          {
            validator: (rule: any, value: any, callback: any) => {
              if (value && value.trim() !== '') {
                callback()
              } else {
                callback(new Error('Company name is required'))
              }
            },
          },
        ],
        companySize: [{ required: true, message: 'Size is required' }],
        companyIndustry: [{ required: true, message: 'Industry is required' }],
        otherIndustry: [
          {
            validator: (rule: any, value: any, callback: any) => {
              // @ts-ignore
              if (this.hasOtherIndustry && this.otherIndustry === '') {
                callback(new Error('Industry is required'))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },

  computed: {
    currentStepInfo(): any {
      return this.stepInfos.find(s => s.id === this.currentStepID)
    },
    currentStepLayoutSize(): string {
      return this.currentStepInfo.layoutSize
    },
    revisitName(): string {
      if (this.completeAccountData.hasUserRegistered) {
        return this.completeAccountData.name
      }

      return null
    },
    hasTokenErrorMessage(): boolean {
      return (
        this.tokenErrorMessage !== undefined &&
        this.tokenErrorMessage.length > 0
      )
    },
    disableStep1Continue(): boolean {
      return !this.formData.acceptTerms
    },
    disableStep2Continue(): boolean {
      return false
    },
  },

  async created() {
    this.isLoading = true
    await this.getCompleteAccountData()
    this.isLoading = false
    this.$nextTick(() => {
      if (this.completeAccountData.hasUserRegistered) {
        // @ts-ignore
        this.$refs.companyRef.focus()
      } else {
        // @ts-ignore
        this.$refs.nameRef.focus()
      }
    })
  },

  methods: {
    continueToStep2() {
      // @ts-ignore
      this.$refs.step1Form.validate(valid => {
        if (valid) {
          this.currentStepID = 2
          this.$nextTick(() => {
            // @ts-ignore
            this.$refs.companyRef.focus()
          })
        }
      })
    },
    toggleOtherIndustry() {
      this.hasOtherIndustry =
        this.formData.companyIndustry.toLowerCase().trim() === 'other'

      if (this.hasOtherIndustry) {
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.otherIndustryRef.focus()
        })
      }
    },
    async submitForm() {
      this.isSubmitting = true
      try {
        // Replace industry with typed in option...
        if (this.hasOtherIndustry) {
          this.formData.companyIndustry = this.otherIndustry
        }

        const response = await RegistrationAPI.post_CreateAccount(this.formData)
        window.location.href = RouteAssistant.getRegistrationAccountAddMembersUrl(
          response.id,
          response.email,
        )
      } catch (error) {
        this.$error.emit(error, true)
        this.isSubmitting = false
      }
    },
    handleStepClick(id: number) {
      // Only move step if it's behind us...
      if (this.currentStepID > id) {
        this.currentStepID = id
      }
    },
    async getCompleteAccountData() {
      try {
        this.completeAccountData = await RegistrationAPI.get_CompleteAccount(
          TextAssistant.urlTokenCleaner(this.$route.query.donedone_token),
          TextAssistant.urlTokenCleaner(this.$route.query.gauth_token),
        )

        this.formData.name = this.completeAccountData.name
        this.formData.couponCode = this.completeAccountData.couponCodeFromPromotionalLink
        this.formData.verificationToken = this.completeAccountData.verificationToken
        this.formData.emailAddress = this.completeAccountData.emailAddress
        this.formData.viaGoogleAuth = this.completeAccountData.viaGoogleAuth
        this.formData.timezone = TimeAssistant.guessTimezoneID()

        this.isCouponCodeExposed =
          this.formData.couponCode != null &&
          this.formData.couponCode.length > 0

        this.completeAccountData.listTaskGoals.forEach(t => {
          this.goalInfos.push({
            type: TextAssistant.itemSingularName(
              EEntities.PROJECTS,
            ).toLowerCase(),
            title: t.name,
            subtitle: t.description,
            selected: false,
          })
        })

        this.completeAccountData.listConversationGoals.forEach(c => {
          this.goalInfos.push({
            type: TextAssistant.itemSingularName(
              EEntities.MAILBOXES,
            ).toLowerCase(),
            title: c.name,
            subtitle: c.description,
            selected: false,
          })
        })

        if (this.completeAccountData.hasUserRegistered) {
          this.steps = [{ id: 2, name: 'Company' }, { id: 3, name: 'Team' }]
          this.currentStepID = 2
        } else {
          this.steps = [
            { id: 1, name: 'You' },
            { id: 2, name: 'Company' },
            { id: 3, name: 'Team' },
          ]
        }
      } catch (error) {
        this.tokenErrorMessage = error.data.message
      }
    },
  },
})
